<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Slot <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-select label="Succursale" multiple="false" v-model="resource.slotable" :default="resource.branch_id"  :options="branches" v-if="branches"></form-select>

                                <form-text label="Nom" v-model="resource.name"/>

                                <form-autocomplete label="Responsable (par défaut)" multiple="false" v-model="resource.user" :default="resource.user_id" :service="UserService"></form-autocomplete>

                                <form-color-picker label="Couleur" v-model="resource.color" :slotable="resource.color"></form-color-picker>

                                <form-toggle label="Public" v-model="resource.is_public"></form-toggle>

                                <form-number label="Ordre d'affichage" v-model="resource.ord" :step="1"></form-number>

                              </fieldset>

                            </tab>
                            <tab name="Authorization">

                                <acl-authorizations v-model="resource.acl" model="Maven.WeeboxCore.Models.Slotable" type="entity"></acl-authorizations>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import RoleService from '../../scope/RoleService.js';
    import UserService from '../../scope/UserService.js';
    import BranchService from '../branch/BranchService.js';
    import SlotableService from './SlotableService.js';
    import Edit from '../../../layouts/Edit.vue';

    import AclModelService from "../authorizations/AclModelService";

    export default {
        extends: Edit,
        data () {
            return {
                users: null,
                branches: [],
                model: null,
                UserService: null,
            }
        },
        mounted: function(){

            this.UserService = UserService;

            BranchService.query().then(response => {
                this.branches = response.data.data
                this.isLoading = false
            });
        },
        methods: {
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.color = this.resource.color || '#000000';
                this.resource.acl = this.resource.acl || [];
            },
            getResource: function(){
                return SlotableService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/calendar/Edit.vue